<ion-content>
  <div class="storage-container">
    <ion-card *ngIf="loading" class="loading-card">
      <ion-card-content>
        <div class="loading-content">
          <ion-spinner name="crescent"></ion-spinner>
          <p>{{ 'STORAGE.LOADING_MESSAGE' | translate }}</p>
        </div>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="error" class="error-card">
      <ion-card-content>
        <div class="error-content">
          <ion-icon name="alert-circle" color="danger"></ion-icon>
          <h3>{{ 'STORAGE.ERROR_TITLE' | translate }}</h3>
          <p>{{ error }}</p>
          <ion-button fill="outline" (click)="loadStorageData()">
            <ion-icon name="refresh" slot="start"></ion-icon>
            {{ 'STORAGE.RETRY' | translate }}
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="storageData && !loading && !error">
      <ion-card-header>
        <ion-card-title>{{ 'STORAGE.TITLE' | translate }}</ion-card-title>
        <ion-card-subtitle>{{ 'STORAGE.ACCOUNT_ID' | translate }}: {{ getAccountDisplayName() }}</ion-card-subtitle>
      </ion-card-header>
      
      <ion-card-content>
        <!-- Total Storage Summary -->
        <div class="storage-summary">
          <div class="total-storage">
            <h2>{{ storageData.totalFormatted || formatBytes(storageData.totalSize) }}</h2>
            <p>{{ 'STORAGE.TOTAL_STORAGE_USED' | translate }}</p>
            <div class="storage-percentage">
              <span class="percentage">{{ getPercentageUsed(storageData.totalSize, storageData.breakdown) }}%</span>
            </div>
          </div>
          
          <!-- Storage Breakdown -->
          <div class="storage-breakdown">
            <h4>{{ 'STORAGE.STORAGE_BREAKDOWN_BY_CATEGORY' | translate }}</h4>
            <div class="breakdown-item" *ngFor="let item of storageData.breakdown | keyvalue">
              <div class="breakdown-label">
                <span class="category">{{ formatCategoryName(item.key) }}</span>
                <span class="count">{{ item.value.count }} {{ item.value.count === 1 ? ('STORAGE.ITEM' | translate) : ('STORAGE.ITEMS' | translate) }}</span>
              </div>
              <div class="breakdown-size">
                <strong>{{ item.value.formatted || formatBytes(item.value.size) }}</strong>
              </div>
            </div>
          </div>

          <!-- Actions -->
          <div class="storage-actions">
            <ion-button fill="outline" (click)="loadDetailedAnalysis()" [disabled]="loading">
              <ion-icon name="analytics" slot="start"></ion-icon>
              {{ 'STORAGE.DETAILED_ANALYSIS' | translate }}
            </ion-button>
            <ion-button fill="outline" (click)="loadStorageData()" [disabled]="loading">
              <ion-icon name="refresh" slot="start"></ion-icon>
              {{ 'STORAGE.REFRESH_STATUS' | translate }}
            </ion-button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Detailed Analysis View -->
    <ion-card *ngIf="storageData?.serialNumberBreakdown && !loading && !error">
      <ion-card-header>
        <ion-card-title>{{ 'STORAGE.DETAILED_STORAGE_ANALYSIS' | translate }}</ion-card-title>
        <ion-card-subtitle>{{ 'STORAGE.BREAKDOWN_BY_KILN' | translate }}</ion-card-subtitle>
      </ion-card-header>
      
      <ion-card-content>
        <div class="detailed-analysis">
          <div class="analysis-summary">
            <div class="summary-item">
              <span class="label">{{ 'STORAGE.TOTAL_FILES' | translate }}:</span>
              <span class="value">{{ storageData.totalFiles }}</span>
            </div>
            <div class="summary-item">
              <span class="label">{{ 'STORAGE.AVERAGE_FILE_SIZE' | translate }}:</span>
              <span class="value">{{ formatBytes(storageData.averageFileSize) }}</span>
            </div>
          </div>

          <div class="kiln-breakdown">
            <h4>{{ 'STORAGE.STORAGE_BY_KILN' | translate }}</h4>
            <div class="kiln-item" *ngFor="let kiln of storageData.serialNumberBreakdown | keyvalue">
              <div class="kiln-header">
                <span class="kiln-name">{{ kiln.key }}</span>
                <span class="kiln-size">{{ formatBytes(kiln.value.totalSize) }}</span>
              </div>
              <div class="kiln-details">
                <span class="file-count">{{ kiln.value.totalFiles }} {{ 'STORAGE.FILES' | translate }}</span>
                <span class="avg-size">{{ 'STORAGE.AVG' | translate }}: {{ formatBytes(kiln.value.averageFileSize) }}</span>
              </div>
            </div>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
